export default "<p>The resource you requested was not found.</p>\n<p>Указанный документ не найден.</p>\n<p>Nic nie znaleziono pod wskazanym adresem.</p>\n";